import React from 'react'

const PagePadding = ({ children }) => {
    return (
        <div className='pl-5 pr-5 md:pr-16 md:pl-16'>{children}</div>
    )
}

export default PagePadding